<template>
  <div class="box">
    <div class="box2">
      <div class="complaintInformation">
        <div class="complaintClassification border_bottom">
          <div class="left">投诉时间</div>
          <div class="right">
            <span>{{itemList.complain_time}}</span>
          </div>
        </div>
      </div>
      <div class="urgent">
        <div class="uploadBox">
            <upload :imgUrl="imgUrl"></upload>
        </div>
        <div class="returnReas">
            <div class="text">调解失败备注</div>
            <div class="textar">
                    <textarea  maxlength="200" placeholder="请输入调解失败备注" class="txtarea" v-model="mediationNote"></textarea>
            </div>
        </div>
      </div>
      <div class="btn">
        <div class="submit">
          <van-button type="primary" @click="handleSubmit" >提交</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import api from '@/service/modules/complaint';
    import util from '@/utils/common'
    import upload from '@/components/uploadCopy'
    export default {
        components: {
            upload
        },
        data () {
            return {
                mediationNote: '',
                itemList: util.getJsonLocal('item'),
                isback:this.$store.state.complaint.isBackDetail||util.getJsonLocal('isBack'),
                imgUrl: [] // 上传的图片
            }
        },
        mounted () {
            this.$on('fileUploadData', val => {
                this.imgUrl = val
            })
        },
        methods: {
            afterRead () {
            },
            // 提交
            handleSubmit () {
                if (this.mediationNote.trim().length === 0||this.mediationNote.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"")==='') {
                    this.$Toast('请输入调解失败备注');
                } else {
                    var resultReson=this.mediationNote.replace(/[\ |\~|\`|\!|\！|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\；|\:|\：|\"|\'|\，|\,|\<|\.|\>|\/|\?]/g,"");
                    if(resultReson.replace(/\s*/g,"").length<=10){
                        this.$Toast('请输入10个字以上的反馈内容');
                        return;
                    }    
                    const data = {
                      type: 'conciliationFail',
                      note: this.mediationNote.replace(/\s*/g,""),
                      result_type: 4,
                      imgUrl: this.imgUrl
                    }
                    api.disposeOperation(data).then((res) => {
                        console.log(res)
                        if (res.ret === 0) {
                            this.$Toast('操作成功');
                            // this.$router.go(-2);
                            if(!this.isback){
                            this.$router.go(-2);
                            }else{
                                this.$router.back();
                                this.$set(this.itemList,'btns',[]);
                                util.setJsonLocal('item',this.itemList);
                            }
                        }
                    })
                }
            }
        }
    }
</script>
<style lang="less" scoped>
.box {
  width: 100%;
//   padding: 14px;
  background-color: #f4f3f3;
  box-sizing: border-box;
  .box2 {
    width: 100%;
    padding: 14px;
    background-color: #fff;
    font-size: 14px;
    box-sizing: border-box;
    .uploadBox{
      margin-top: 20px;
    }
    .complaintInformation {
      width: 100%;
      .complaintClassification,
      .objectofcomplaint,
      .complaint,
      .specificSituation
     {
        display: flex;
        height: 50px;
        line-height: 50px;
        .left {
          float: left;
          width: 50%;
          text-align: left;
          color: #aaa;
        }
        .right {
          float: left;
          width: 50%;
          text-align: right;
        }
      }
      .complaintClassification,
      .objectofcomplaint,
      .complaint,
      .specificSituation {
        .right {
          color: #333;
          font-size: 14px;
        }
      }
      .complaintTarget_class {
        color: #000000;
      }
    }
    .companyName {
      height: 50px;
      line-height: 50px;
    }
    .emergencyLevel {
      width: 100%;
      height: 50px;
      line-height: 50px;
    }
    .urgent {
      width: 100%;
      font-size: 14px;
      .limitedProcesseTime {
        width: 100%;
        height: 50px;
        line-height: 50px;
        display: flex;
        .left {
          width: 40%;
          color: #aaa;
        }
        .right {
          width: 55%;
          margin-left: 15px;
          display: flex;
          .van-field {
            border-bottom: 1px solid #ccc;
            height: 30px;
            margin-top: 10px;
            padding: 0;
          }
          span {
            color: #aaa;
          }
        }
      }
        .van-uploader {
                margin-top: 20px;
            }
      .upload{
            height: 44px;
            line-height: 50px;

            .upattach{
                font-size: 14px;
                color: #444444;
            }
            span{
                font-size: 12px;
                color: #BFBFBF;
            }
        }.returnReas{
            font-size: 14px;
            margin-top:100px;
            .text{
                height: 20px;
                // color: #9C9C9C;
                color: #BFBFBF;
                // margin-left: 0.426667rem;
                padding-bottom:15px;
            }
            .textar{
                margin-top: 5px;
                height: 110px;
                width: 100%;
                text-align: center;
                .txtarea{
                    border: none;
                    border-radius: 5px;
                    padding-top: 10px;
                    padding-left: 10px;
                    background-color:#F2F2F2;
                    height: 100px;
                    width: 340px;
                    resize: none;
                }
            }
        }
      .emergencyLabel,
      .complaintClass {
        width: 100%;
        height: 50px;
        line-height: 50px;
        display: flex;
        .left {
          width: 30%;
          color: #aaa;
        }
        .right {
          display: flex;
          width: 50%;
          justify-content: space-between;
          div {
            width: 50px;
            height: 30px;
            line-height: 30px;
            margin-top: 10px;
            text-align: center;
            background-color: #fff;
            color: #aaa;
          }
          .tabColor {
            background-color: #3C8DE5;
            color: #fff;
          }
        }
      }
    }
    .btn {
      margin-top: 30px;
      .van-button {
        width: 100%;
        border-radius: 7px;
        margin-top: 10px;
      }
      .back {
        .van-button {
          color: #bdb8b8;
        }
        .van-button--plain {
          background-color: #efeded;
        }
      }
    }
    .border_bottom {
      border-bottom: 1px solid #eee;
    }
  }
}
</style>
